import React from "react"

import { Grid, Typography, Button, Chip } from "@material-ui/core"

import useStyles from "@/pages/SmartConversions/styles"

import Breadcrumb from "@/components/BreadcrumbNew"

import PeopleOnRocketSVGIcon from "@/assets/images/illustrations/people_on_rocket.svg"
import StarRateSVGIcon from "@/assets/icons/star_rate_icon.svg"

import { AlertContainer } from "@/components"
import { CheckBox } from "@material-ui/icons"
import { themeColors } from "letalkui"
import { whatsappLinks } from "@/utils/link"

const SmartConversions: React.FC = () => {
	const classes = useStyles()

	const SMART_CONVERSIONS_INFOS: Array<{
		title: string
		benefits: string[]
	}> = [
		{
			title: "Links Rastreáveis",
			benefits: [
				"Identifique a origem de cada lead (Instagram, site, Google etc.).",
				"Personalize o atendimento automático conforme o canal de origem.",
				"Acompanhe o desempenho de botões e campanhas com precisão."
			]
		},
		{
			title: "Eventos de Conversão para a Meta",
			benefits: [
				"Envio automático de eventos para o Facebook/Instagram Ads.",
				"Campanhas otimizadas com base em conversões reais.",
				"Melhor custo por resultado (CPR) e retargeting mais inteligente."
			]
		},
		{
			title: "Relatórios UTM",
			benefits: [
				"Visualize dados de campanhas com parâmetros UTM completos.",
				"Compare fontes e anúncios de forma objetiva.",
				"Descubra o que realmente traz leads qualificados."
			]
		}
	]

	return (
		<Grid
			container
			direction="column"
			spacing={6}
		>
			<Grid item>
				<Grid container direction="column" spacing={3}>
					<Grid item>
						<Breadcrumb
							data={[
								{ name: "Conversões Inteligentes", pathname: "/smart-conversions" }
							]}
						/>
					</Grid>

					<Grid item>
						<Grid container direction="column">
							<Grid item>
								<Chip
									size="small"
									label={"MÓDULO ADICIONAL"}
									className={classes.planTag}
									icon={
										<img
											src={StarRateSVGIcon}
											style={{
												height: "24px",
												width: "24px"
											}}
										/>
									}
								/>
							</Grid>

							<Grid item>
								<Typography
									className={classes.calloutTitle}
								>
									Este recurso faz parte do módulo de Conversões Inteligentes
								</Typography>

								<Typography
								>
									Você tentou acessar uma funcionalidade exclusiva do módulo Conversões Inteligentes, que não está disponível no seu plano atual.
								</Typography>
							</Grid>

							<Grid
								item
								className={classes.alertContainer}
							>
								<AlertContainer
									alertType="info"
								>
									<Typography
										className={classes.alertText}
									>
										Esse módulo reúne as ferramentas ideais para transformar cliques e campanhas em dados estratégicos
									</Typography>
								</AlertContainer>
							</Grid>

							<Grid item>
								<Grid container direction="row">
									<Grid item xs={6}>
										<Grid container>
											<Grid item>
												<Typography
												>
													{
														SMART_CONVERSIONS_INFOS.map((SMART_CONVERSIONS_INFO, index) => {
															return (
																<Grid
																	item
																	xs={12}
																	key={index}
																>
																	<Grid
																		container
																		spacing={1}
																		className={classes.listedItem}
																	>
																		<Grid
																			item
																		>
																			<Grid
																				container
																				alignItems="flex-start"
																			>
																				<CheckBox
																					style={{
																						width: 24,
																						height: 24,
																						fill: themeColors.colors.system.green[500]
																					}}
																				/>
																			</Grid>
																		</Grid>
																		<Grid
																			item
																			xs={10}
																		>
																			<Typography
																			>
																				<strong>{SMART_CONVERSIONS_INFO.title}:</strong>
																			</Typography>
																		</Grid>
																	</Grid>

																	<Grid
																		item
																		className={classes.bulletedListContainer}
																	>
																		<ul>
																			{
																				SMART_CONVERSIONS_INFO.benefits.map((SMART_CONVERSIONS_INFO_BENEFIT, index) => {
																					return (
																						<li key={index}>{SMART_CONVERSIONS_INFO_BENEFIT}</li>
																					)
																				})
																			}
																		</ul>
																	</Grid>
																</Grid>
															)
														})
													}
												</Typography>
											</Grid>

											<Grid
												item
											>
												<Typography
												>
													Resumindo: você vende mais, investe melhor e toma decisões com base em dados reais.
												</Typography>
											</Grid>

											<Grid
												item
											>
												<Button
													className={classes.button}
													variant="contained"
													href={whatsappLinks.sendMessageToAcquireSmartConversionsModule}
													target="_blank"
												>
													Falar com consultor
												</Button>
											</Grid>
										</Grid>
									</Grid>

									<Grid item xs={6}>
										<img
											src={PeopleOnRocketSVGIcon}
											className={classes.calloutImage}
										/>
									</Grid>
								</Grid>
							</Grid>
						</Grid>
					</Grid>
				</Grid>
			</Grid>
		</Grid>
	)
}

export default SmartConversions
